import { MenuConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';


export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: ActionType.ADD_REVISION,
        content: i18n.t<string>('上传新版本'),
    },
];
